import type { IconData } from '@stacksjs/iconify-core'

export const chevronDoubleUpAlt: IconData = {
  "body": "<path d=\"M20.095 20.405L12 12.31l-8.095 8.095l-1.061-1.061l9.155-9.155l9.155 9.155l-1.061 1.061z\" fill=\"currentColor\"/><path d=\"M20.095 12.905L12 4.81l-8.095 8.095l-1.061-1.061l9.155-9.155l9.155 9.155l-1.061 1.061z\" fill=\"currentColor\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default chevronDoubleUpAlt
